import { render } from "./ClientDashboard.vue?vue&type=template&id=7a5b5bc4&scoped=true"
import script from "./ClientDashboard.vue?vue&type=script&lang=js"
export * from "./ClientDashboard.vue?vue&type=script&lang=js"

import "./ClientDashboard.vue?vue&type=style&index=0&id=7a5b5bc4&lang=css"
import "./ClientDashboard.vue?vue&type=style&index=1&id=7a5b5bc4&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5b5bc4"]])

export default __exports__